import { MenuBook } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { FC, useState } from 'react'

import { VehicleEntry } from '../../sdk'
import LaborGuideDialog from './LaborGuideDialog'

interface Props {
  vehicle: VehicleEntry | undefined
}

const LaborGuideButton: FC<Props> = ({ vehicle }) => {
  const [laborGuideOpen, setLaborGuideOpen] = useState(false)

  return (
    <>
      {laborGuideOpen && (
        <LaborGuideDialog
          handleClose={() => setLaborGuideOpen(false)}
          vehicle={vehicle}
        />
      )}
      <Tooltip title={'Repair Manual'}>
        <IconButton
          onClick={() => setLaborGuideOpen(true)}
          data-testid="repairManualButton">
          <MenuBook />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default LaborGuideButton
